/** @jsxImportSource react */
import React from 'react';

import { ToolGrid } from './Styles';
import ToolCard from './ToolCard';
import { ToolCardListProps } from '../types';

const ToolCardList: React.FC<ToolCardListProps> = ({ items }) => {
  return (
    <ToolGrid>
      {items.map((item, index) => (
        <ToolCard
          item={item}
          key={index}
          eventProps={{ location: 'tools', text: item?.title }}
        />
      ))}
    </ToolGrid>
  );
};

export default ToolCardList;
